function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { htmlPropType } from '../utils/propTypes';
import { TOOLTIP_CONTENT_PROPTYPE, ARROW_LOCATION_PROPTYPE, STYLE_PROPTYPE, ANIMATION_MAP, STANDARD_ARROW_SPACING } from './constants';
import { getLocation } from './utils';

var _updatePosition = function _updatePosition(initialLocation, finalArrowLocation) {
  var verticalVals = ['bottom', 'top'];
  var negativeVals = ['bottom', 'right'];
  var key = 'left';
  var spacing = STANDARD_ARROW_SPACING;

  if (verticalVals.indexOf(finalArrowLocation) > -1) {
    key = 'top';
  }

  if (negativeVals.indexOf(finalArrowLocation) > -1) {
    spacing = -spacing;
  }

  var adjustedValue = initialLocation[key] + spacing;
  return _objectSpread({}, initialLocation, _defineProperty({}, key, adjustedValue));
};

var Tooltip =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Tooltip, _React$PureComponent);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));
    _this.state = {
      targetNode: props.targetNode,
      height: -1,
      width: -1
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var targetNode = _ref.targetNode;
      this.setState({
        targetNode: targetNode
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this._toolTipNode && !this._componentIsRendered()) {
        /* Needed to trigger a re-render once the component has actually
        been mounted and we have access to its height and width */
        //eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          height: this._toolTipNode.offsetHeight,
          width: this._toolTipNode.offsetWidth
        });
      }
    }
  }, {
    key: "_setToolTipNode",
    value: function _setToolTipNode(node) {
      if (node) {
        this._toolTipNode = node;
      }
    }
  }, {
    key: "_componentIsRendered",
    value: function _componentIsRendered() {
      return this.state.height > -1 && this.state.width > -1;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.targetNode) {
        return null;
      }

      var finalLocation;
      var _this$props = this.props,
          children = _this$props.children,
          arrowLocation = _this$props.arrowLocation,
          style = _this$props.style,
          tooltipId = _this$props.tooltipId;
      var _this$state = this.state,
          targetNode = _this$state.targetNode,
          height = _this$state.height,
          width = _this$state.width;

      if (this._componentIsRendered()) {
        var initialLocation = getLocation(targetNode, arrowLocation, width, height);
        finalLocation = _updatePosition(initialLocation, arrowLocation);
      }

      var className = classNames('eds-tooltip', "eds-tooltip__arrow-".concat(arrowLocation), "eds-tooltip--".concat(style), _defineProperty({}, ANIMATION_MAP[arrowLocation], finalLocation));
      return React.createElement("div", {
        id: tooltipId,
        className: className,
        style: finalLocation,
        ref: this._setToolTipNode.bind(this),
        "data-spec": "tooltip",
        role: "tooltip"
      }, children);
    }
  }]);

  return Tooltip;
}(React.PureComponent);

_defineProperty(Tooltip, "propTypes", {
  /**
   * The text to be set as id for tooltip
  **/
  tooltipId: PropTypes.string,

  /**
   * The text or React element to be displayed.
   * If text is provided, it must be a label, no sentences, with a max character count of 32.
  **/
  children: TOOLTIP_CONTENT_PROPTYPE.isRequired,

  /**
   * HTML DOM node of the element which when hovered over will
   * trigger the Tooltip to appear.
  **/
  targetNode: htmlPropType,

  /**
   * Location of arrow relative to targetNode. The direction chosen
   * relates to which side of the Tooltip the arrow will appear.
   * Options: left, right, top, bottom
  **/
  arrowLocation: ARROW_LOCATION_PROPTYPE,

  /**
   * The background color of the Tooltip. Options: basic, phab
  **/
  style: STYLE_PROPTYPE
});

_defineProperty(Tooltip, "defaultProps", {
  arrowLocation: 'top',
  style: 'basic'
});

export { Tooltip as default };